import React from 'react';

export const WistiaResponsivePadding = {
  padding: '56.25% 0 0 0',
  position: 'relative',
  width: '100%',
} as React.CSSProperties;

export const WistiaResponsiveWrapper = {
  position: 'absolute',
  left: 0,
  top: 0,
  height: '100%',
  width: '100%',
} as React.CSSProperties;

export const ModalWistiaWrapper = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '80vw',
} as React.CSSProperties;
